import { render } from "./EditMaterial.vue?vue&type=template&id=29b1d3f4&scoped=true"
import script from "./EditMaterial.vue?vue&type=script&lang=js"
export * from "./EditMaterial.vue?vue&type=script&lang=js"

import "./EditMaterial.vue?vue&type=style&index=0&id=29b1d3f4&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b1d3f4"]])

export default __exports__